<template>
  <!-- Tab Navigation -->
  <div class="border-b border-gray-200">
    <Page_Tabs
      :tabs="tabNames"
      :initialTab="activeTabName"
      @select="onTabSelect"
    />
  </div>

  <!-- Tab Content -->
  <div class="p-6">
    <transition
      name="fade"
      mode="out-in"
    >
      <component :is="currentTabComponent" :key="activeTab" />
    </transition>
  </div>
</template>

<script>
import EngagementVelocity from './EngagementVelocity.vue'
import EngagementCoverage from './EngagementCoverage.vue'
import Page_Tabs from '@/components/widgetcomponents/Page_Tabs.vue'

export default {
  name: 'EngagementStatsOverview',
  components: {
    EngagementVelocity,
    EngagementCoverage,
    Page_Tabs
  },
  data() {
    return {
      activeTab: 'velocity',
      tabs: [
        {
          id: 'velocity',
          name: 'Engagement Velocity',
          component: 'EngagementVelocity'
        },
        {
          id: 'coverage',
          name: 'Engagement Coverage',
          component: 'EngagementCoverage'
        }
      ]
    }
  },
  computed: {
    tabNames() {
      return this.tabs.map(t => t.name)
    },
    activeTabName() {
      const tab = this.tabs.find(t => t.id === this.activeTab)
      return tab ? tab.name : this.tabs[0].name
    },
    currentTabComponent() {
      const tab = this.tabs.find(t => t.id === this.activeTab)
      return tab ? tab.component : 'EngagementVelocity'
    }
  },
  methods: {
    onTabSelect(tabName) {
      const tab = this.tabs.find(t => t.name === tabName)
      if (tab) {
        this.activeTab = tab.id
      }
    }
  },
  mounted() {
    // Check if there's a tab parameter in the URL
    const urlParams = new URLSearchParams(window.location.search)
    const tabParam = urlParams.get('tab')
    if (tabParam && this.tabs.some(t => t.id === tabParam)) {
      this.activeTab = tabParam
    }
  },
  watch: {
    activeTab(newTab) {
      // Update URL without reloading page
      const url = new URL(window.location)
      url.searchParams.set('tab', newTab)
      window.history.pushState({}, '', url)
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
